import React, { FC, ReactNode } from 'react';
import Header from '../Header/Header';
import Content from '../Content/Content';
import Footer from '../Footer/Footer';
import Page from '../Page/Page';
import { Container } from 'react-bootstrap';

interface PageProps {
  children: ReactNode;
}

const SimplePage: FC<PageProps> = ({ children }) => {
  return (
    <Page>
      <Header />
      <Content>
        <Container>
          <div className="pt-4 pb-4">{children}</div>
        </Container>
      </Content>
      <Footer />
    </Page>
  );
};

export default SimplePage;
